/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {Error} from '../models/Error';
import type {Limit} from '../models/Limit';
import type {TempLimit} from '../models/TempLimit';

export interface GetAccountTempLimits$Request {
    accountId: number;
}

export interface GetAccountTempLimits$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getAccountTempLimitsRequest = createAction<PayloadData<void, GetAccountTempLimits$Request>>('ACCOUNT_TEMPORARY_LIMITS__GET_ACCOUNT_TEMP_LIMITS__REQUEST');
export const getAccountTempLimitsSuccess = createAction<PayloadData<Array<TempLimit>, GetAccountTempLimits$Request>>('ACCOUNT_TEMPORARY_LIMITS__GET_ACCOUNT_TEMP_LIMITS__SUCCESS');
export const getAccountTempLimitsFailure = createAction<PayloadData<Error, GetAccountTempLimits$Request, true>>('ACCOUNT_TEMPORARY_LIMITS__GET_ACCOUNT_TEMP_LIMITS__FAILURE');

export const getAccountTempLimitsActions = [
    getAccountTempLimitsRequest,
    getAccountTempLimitsSuccess,
    getAccountTempLimitsFailure
] as const;

/**
 * @param {number} meta.accountId
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getAccountTempLimits = (meta: GetAccountTempLimits$Request, config?: GetAccountTempLimits$Config) => {
    return {
        CALL_API: {
            types: getAccountTempLimitsActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/accounts/${meta.accountId}/temporaries-limits`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface RemoveAccountTemporaryLimit$Request {
    accountId: number;
    requestBody: Array<string>;
}

export interface RemoveAccountTemporaryLimit$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const removeAccountTemporaryLimitRequest = createAction<PayloadData<void, RemoveAccountTemporaryLimit$Request>>('ACCOUNT_TEMPORARY_LIMITS__REMOVE_ACCOUNT_TEMPORARY_LIMIT__REQUEST');
export const removeAccountTemporaryLimitSuccess = createAction<PayloadData<void, RemoveAccountTemporaryLimit$Request>>('ACCOUNT_TEMPORARY_LIMITS__REMOVE_ACCOUNT_TEMPORARY_LIMIT__SUCCESS');
export const removeAccountTemporaryLimitFailure = createAction<PayloadData<Error, RemoveAccountTemporaryLimit$Request, true>>('ACCOUNT_TEMPORARY_LIMITS__REMOVE_ACCOUNT_TEMPORARY_LIMIT__FAILURE');

export const removeAccountTemporaryLimitActions = [
    removeAccountTemporaryLimitRequest,
    removeAccountTemporaryLimitSuccess,
    removeAccountTemporaryLimitFailure
] as const;

/**
 * @param {number} meta.accountId
 * @param {Array<string>} meta.requestBody
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const removeAccountTemporaryLimit = (meta: RemoveAccountTemporaryLimit$Request, config?: RemoveAccountTemporaryLimit$Config) => {
    return {
        CALL_API: {
            types: removeAccountTemporaryLimitActions,
            method: ApiMethods.DELETE,
            endpoint: `/web-api/accounts/${meta.accountId}/temporaries-limits`,
            TRANSPORT_REQUEST_BODY: meta.requestBody,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface SaveAccountTemporaryLimit$Request {
    accountId: number;
    expiresOn: string;
    limit: Array<Limit>;
}

export interface SaveAccountTemporaryLimit$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const saveAccountTemporaryLimitRequest = createAction<PayloadData<void, SaveAccountTemporaryLimit$Request>>('ACCOUNT_TEMPORARY_LIMITS__SAVE_ACCOUNT_TEMPORARY_LIMIT__REQUEST');
export const saveAccountTemporaryLimitSuccess = createAction<PayloadData<void, SaveAccountTemporaryLimit$Request>>('ACCOUNT_TEMPORARY_LIMITS__SAVE_ACCOUNT_TEMPORARY_LIMIT__SUCCESS');
export const saveAccountTemporaryLimitFailure = createAction<PayloadData<Error, SaveAccountTemporaryLimit$Request, true>>('ACCOUNT_TEMPORARY_LIMITS__SAVE_ACCOUNT_TEMPORARY_LIMIT__FAILURE');

export const saveAccountTemporaryLimitActions = [
    saveAccountTemporaryLimitRequest,
    saveAccountTemporaryLimitSuccess,
    saveAccountTemporaryLimitFailure
] as const;

/**
 * @param {number} meta.accountId
 * @param {string} meta.expiresOn
 * @param {Array<Limit>} meta.limit
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const saveAccountTemporaryLimit = (meta: SaveAccountTemporaryLimit$Request, config?: SaveAccountTemporaryLimit$Config) => {
    const TRANSPORT_GET_PARAMS = {
        expiresOn: meta.expiresOn,
    };
    return {
        CALL_API: {
            types: saveAccountTemporaryLimitActions,
            method: ApiMethods.PATCH,
            endpoint: `/web-api/accounts/${meta.accountId}/temporaries-limits`,
            TRANSPORT_GET_PARAMS,
            TRANSPORT_REQUEST_BODY: meta.limit,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

